import { z } from 'zod';

export const componentStatusSchema = z.object({
  ok: z.boolean(),
  latencyMs: z.number().nonnegative().optional(),
  message: z.string().optional(),
});

export const healthResponseSchema = z.object({
  ok: z.boolean(),
  version: z.string(),
  uptimeSeconds: z.number().nonnegative(),
  components: z.object({
    database: componentStatusSchema,
    redis: componentStatusSchema,
  }),
});

export type ComponentStatus = z.infer<typeof componentStatusSchema>;
export type HealthResponse = z.infer<typeof healthResponseSchema>;

/** Response of hearthd `GET /api/system`. */
export const daemonSystemSchema = z.object({
  version: z.string(),
  os: z.string(),
  arch: z.string(),
  cpuCount: z.number().int(),
  docker: z.object({
    ok: z.boolean(),
    runtime: z.string(),
    socket: z.string(),
    serverVersion: z.string().optional(),
    arch: z.string().optional(),
    memoryBytes: z.number().optional(),
    cpus: z.number().optional(),
    /** Probed once hearthd has connected to Docker. */
    amd64Emulation: z.boolean().optional(),
    ioWeight: z.boolean().optional(),
    error: z.string().optional(),
  }),
});

export type DaemonSystem = z.infer<typeof daemonSystemSchema>;
